<template>
  <div>
    <builderall-loader :loading="loadingAll" class="ba-card ba-w-100">
      <div
        class="ba-flex ba-jc-sb ba-ai-center ba-w-100"
        v-if="!connected"
      >
        <span class="ba-title ba-h-100 ba-ai-center">
          {{ $t("ct-domain-info") }}
        </span>
      </div>
      <div
        class="ba-flex ba-jc-sb ba-ai-center ba-w-100"
        v-else
      >
        <span class="ba-title ba-h-100 ba-ai-center">
          {{ $t("ct-domain-info") }}
        </span>
        <div class='ba-box-items ba-flex ba-gp-1'>
            <button class="ba-btn ba-sm ba-blue" @click="back()">
              {{ $t("ct-return") }}
            </button>
        </div>
      </div>
      <br>
      <hr class="ba-hr-row">
      <br>
      <div class="ba-content ba-grid ba-gp-1" v-if="!premium">
        <p class="ba7-subtitle">{{ $t("ct-domain-connect") }}</p>
        <p class="ba7-description">{{ $t("ct-domain-exclusive") }}</p>
        <div class="row mb-4">
          <div class="col-md-5">
            <button type="button" class="btn btn-primary btn-block">
              <i class="svg-icon svgi-cart" />
              {{ $t("ct-builderall-premium") }}
            </button>
          </div>
        </div>
      </div>
      <div class="ba-content ba-grid ba-gp-1" v-else-if="!connected">
        <p class="ba7-subtitle">{{ $t("ct-domain-connect") }}</p>
        <p class="ba7-description" v-text="$t('ct-connect-domain-helper')"></p>
        <form action="#">
          <div class='ba-box-input'>
              <div class='ba-info'>
                  <div class='ba-info-left'>
                      <label class='ba-label' for="domain" v-text="$t('ct-domain')"></label>
                  </div>
              </div>
              <input
                type='url'
                id='domain'
                :class="{'ba-input ba-md': true, 'ba-error': connectError}"
                :placeholder="$t('ct-domain')"
                @change="replaceWWW"
                @keyup="replaceWWW"
                v-model="domain"
              />
              <span v-if="connectError" class='ba-validation-text' v-text="errorMsg"></span>
          </div>
          <br>
          <div class="ba-flex ba-jc-fe ba-w-100 ba-gp-1">
            <button
              type="button"
              class="ba-btn ba-md ba-green"
              @click.prevent="buyDomain"
            >
              <i class="svg-icon svgi-cart" />
              {{ $t("ct-buy-domain") }}
            </button>
            <button
            @click.prevent="confirmConnect()"
            :disabled="!domain"
            v-if="premium"
            class="ba-btn ba-md ba-blue"
          >
            {{ $t("ct-connect") }}
          </button>
          </div>
        </form>
      </div>
      <div class="ba-content ba-grid ba-gp-1" v-else>
        <div class='ba-box-input'>
            <div class='ba-info'>
                <div class='ba-info-left'>
                    <label class='ba-label' for="domain" v-text="$t('ct-domain')"></label>
                </div>
            </div>
            <div class="ba-box-input-icon">
              <input
                type="text"
                id="domain"
                :value="displayDomain"
                class="ba-input ba-md ba-w-100"
                @click="copy"
                readonly
              />
              <div>
                <button class='ba-button' @click="copy('domain')">
                  <builderall-icon code='b54c'></builderall-icon>
                </button>
              </div>
            </div>
            <p class="little-info">{{ $t("ct-you-purchased-your-domain-with-us") }}</p>
        </div>
        <p class="ba7-subtitle">{{ $t("ct-domain-message-steps") }}</p>
        <ol class="ba7-ol-list">
          <li>{{ $t("ct-domain-step-1") }}</li>
          <li>{{ $t("ct-domain-step-2") }}</li>
          <li>{{ $t("ct-domain-step-3") }}</li>
        </ol>
        <div class="ba-flex ba-gp-1">
          <div class='ba-box-input ba-w-100'>
            <div class='ba-info'>
                <div class='ba-info-left'>
                    <label class='ba-label' for="ns_1">Name Server 1:</label>
                </div>
            </div>
            <div class="ba-box-input-icon">
              <input
                type="text"
                id="ns_1"
                :value="ns_1"
                class="ba-input ba-md ba-w-100"
                @click="copy"
                readonly
              />
              <div>
                <button class='ba-button' @click="copy('ns_1')">
                  <builderall-icon code='b54c'></builderall-icon>
                </button>
              </div>
            </div>
          </div>
          <div class='ba-box-input ba-w-100'>
            <div class='ba-info'>
                <div class='ba-info-left'>
                    <label class='ba-label' for="ip1">IP 1:</label>
                </div>
            </div>
            <div class="ba-box-input-icon">
              <input
                type="text"
                id="ip1"
                :value="ip1"
                class="ba-input ba-md ba-w-100"
                @click="copy"
                readonly
              />
              <div>
                <button class='ba-button' @click="copy('ip1')">
                  <builderall-icon code='b54c'></builderall-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="ba-flex ba-gp-1">
          <div class='ba-box-input ba-w-100'>
            <div class='ba-info'>
                <div class='ba-info-left'>
                    <label class='ba-label' for="ns_2">Name Server 2:</label>
                </div>
            </div>
            <div class="ba-box-input-icon">
              <input
                type="text"
                id="ns_2"
                :value="ns_2"
                class="ba-input ba-md ba-w-100"
                @click="copy"
                readonly
              />
              <div>
                <button class='ba-button' @click="copy('ns_2')">
                  <builderall-icon code='b54c'></builderall-icon>
                </button>
              </div>
            </div>
          </div>
          <div class='ba-box-input ba-w-100'>
            <div class='ba-info'>
                <div class='ba-info-left'>
                    <label class='ba-label' for="ip2">IP 2:</label>
                </div>
            </div>
            <div class="ba-box-input-icon">
              <input
                type="text"
                id="ip2"
                :value="ip2"
                class="ba-input ba-md ba-w-100"
                @click="copy"
                readonly
              />
              <div>
                <button class='ba-button' @click="copy('ip2')">
                  <builderall-icon code='b54c'></builderall-icon>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div class="ba-flex ba-gp-1 ba-jc-sb ba-mg-t-1 ba-mg-b-1">
          <div class="ba-flex ba-gp-02 ba-f-column">
            <p class="ba-subtitle">
              {{ $t("ct-or-condition") }}
            </p>
            <a class="link-domain" target="_blank" :href="$t('ct-connect-domain-without-link')">{{ $t('ct-connect-domain-without-changing-nameserver') }}</a>
          </div>
          <button
            slot="button"
            class="ba-btn ba-red ba-md"
            @click="confirmDisconnect()"
          >
            {{ $t("ct-domain-disconnect") }}
          </button>
        </div>
      </div>
    </builderall-loader>

    <!-- connect modal -->
    <sweet-modal
      ref="confirmConnect"
      :title="this.$t('ct-connect-domain-confirm')"
      width="30%"
      blocking
    >
      <div class="border bg-light p-5 text-center mt-4">
        <p>
          {{ $t("want-connect-domain") }}:
          <strong>{{ domain }}</strong>
        </p>
      </div>

      <button
        slot="button"
        class="btn btn-outline-light"
        @click="cancelConfirmConnect()"
      >
        {{ $t("ct-cancel") }}
      </button>
      <button slot="button" class="btn btn-success" @click="connectDomain()">
        <i class="svg-icon svgi-link"></i>{{ $t("ct-confirm-template-save") }}
      </button>
    </sweet-modal>

    <!-- disconnect modal -->
    <sweet-modal
      ref="confirmDisconnect"
      :title="this.$t('title-disconnect-domain-confirm')"
      width="30%"
      blocking
    >
      <div class="border bg-light p-5 text-center mt-4">
        <p>
          {{ $t("want-disconnect-domain") }}:
          <strong> {{ displayDomain }}</strong>
        </p>
      </div>

      <button
        slot="button"
        class="btn btn-outline-light"
        @click="cancelConfirmDisconnect()"
      >
        {{ $t("ct-cancel") }}
      </button>
      <button slot="button" class="btn btn-danger" @click="disconnectDomain()">
        <i class="svg-icon svgi-link"></i
        >{{ $t("ct-domain-disconnect-action") }}
      </button>
    </sweet-modal>
    <modal-upgrade-bundle ref="modal-upgrade-bundle"></modal-upgrade-bundle>
  </div>
</template>

<script>
import axios from "axios";
import { get } from "../../../js/services/editor/website";
import { connect, disconnect } from "../../../js/services/editor/domain";
import { SweetModal } from "sweet-modal-vue";
import Collapse from "../components/Collapse.vue";
import ModalUpgradeBundle from "../components/ModalUpgradeBundle.vue";
export default {
  name: "Domain",
  components: { SweetModal, Collapse, ModalUpgradeBundle },
  data() {
    return {
      ip1: "",
      ip2: "",
      ns_1: "",
      ns_2: "",
      domain: "",
      domainUnicode: "",
      id: this.$route.params.id,
      title: "",
      site: "",
      connected: false,
      premium: true,
      connectError: false,
      errorMsg: this.$t("ct-alert-domain"),
      loadingAll: false
    };

  },
  computed: {
    displayDomain() {
      return this.domainUnicode || this.domain;
    },
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.loadingAll = true;
      get(this.id)
        .then((res) => {
          if (res.data) {
            this.domain = res.data.dominio;
            this.domainUnicode = res.data.domain_unicode;
            this.title = res.data.title;
            this.site = res.data.access_url;
            this.connected = res.data.dominio ? true : false;
          }
          this.getInfo();
        })
        .finally(() => {
          this.loadingAll = false;
        });
    },

    replaceWWW() {
      var match = /^(https?:\/\/[w]{1,3}\.|[w]{1,3}\.)/i;
      if (this.domain.match(match)) {
        this.domain = this.domain.replace(match, '')
      }
    },
    getInfo() {
      let vm = this;
      if (vm.domain) {
        axios
          .get(
            `https://dns.builderall.com/api/domain/get-ns?domain=${vm.domain}`
          )
          .then((res) => {
            if (res.data.success) {
              const dado = res.data;
              vm.ip1 = dado.ip_addresses.ip_1;
              vm.ip2 = dado.ip_addresses.ip_2;
              vm.ns_1 = dado.ns_servers.server_1;
              vm.ns_2 = dado.ns_servers.server_2;
            }
          });
      }
    },

    confirmDisconnect() {
      this.$refs.confirmDisconnect.open();
    },

    confirmConnect() {
      if (this.$isBundle()) {
        this.$refs['modal-upgrade-bundle'].open();
        return;
      }
      this.$refs.confirmConnect.open();
    },

    disconnectDomain() {
      this.$refs.confirmDisconnect.close();
      let obj = {};
      obj.name = this.domain;
      obj.encrypted_id = this.id;

      this.$loading.show();
      disconnect(obj)
        .then((res) => {
          if (res.data.success) {
            this.$snotify.success(this.$t("ct-success-action"));
            this.init();
            window.location.reload();
          } else {
            this.$snotify.error(res.data.error);
          }
        })
        .finally(() => this.$loading.hide());
    },

    connectDomain() {
      this.$refs.confirmConnect.close();
      let obj = {};
      obj.name = this.domain;
      obj.encrypted_id = this.id;

      this.$loading.show();
      connect(obj)
        .then((res) => {
          if (res.data.success) {
            this.$snotify.success(this.$t("ct-domain-connected-successfully"));
            this.init();
            setTimeout(() => {
              window.location.reload();
            }, 2000)
          } else {
            this.connectError = true;
            this.$snotify.error(this.$t(res.data.error));
            this.errorMsg = this.$t(res.data.error)
          }
        })
        .finally(() => {
          this.$loading.hide()
        });
    },

    buyDomain() {
      var win = window.open(
        "https://office.builderall.com/us/office/buy-domain?step=0",
        "_blank"
      );
      win.focus();
    },

    copy(n) {
      let copyText =
        typeof n === "string" ? document.getElementById(n) : n.target;
      copyText.select();
      copyText.setSelectionRange(0, 99999);
      document.execCommand("copy");
      copyText.setSelectionRange(0, 0);
      this.$snotify.info(this.$t("ct-copyed-success"));
    },

    cancelConfirmConnect() {
      this.$refs.confirmConnect.close();
    },

    cancelConfirmDisconnect() {
      this.$refs.confirmDisconnect.close();
    },

    back() {
      window.history.back();
    },
  },
};
</script>

<style lang="scss" scoped>
.ba-card{
  .ba7-subtitle{
    color: #4D5D71;
    font-size: 14px;
    font-weight: bold;
  }
  .ba7-description{
    color: #4D5D71;
    font-size: 12px;
    font-weight: 500;
  }
  .ba-label {
    font-size: 14px;
    font-weight: 500;
    color: #111827;
    margin: 0;
    font-weight: 500;
  }
  .ba7-ol-list{
    font-family: Montserrat;
    font-size: 12px;
    font-weight: 500;
    line-height: 14.63px;
    letter-spacing: 0.055em;
    text-align: left;
    color: #4D5D71;
    padding-left: 16px;
    margin: 0;
    li{
      margin-bottom: 8px;
    }
  }
}
.little-info {
  color: #0072E1;
  font-size: 14px;
  font-weight: 500;
}
.pospend {
  input,
  i {
    cursor: pointer;
  }

  i {
    position: absolute;
    right: 15px;
    top: 10px;
  }
}

.link-domain {
  color: #0072E1;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  text-decoration: underline;
}

.sweet-modal {
  p {
    font-size: 18px;
    font-weight: 600;
    color: #092058;
    font-family: Lato !important;

    strong {
      color: #20cb9b;
      font-family: Lato !important;
      text-transform: lowercase;
    }
  }

  .svgi-link {
    filter: brightness(2);
  }

  button {
    text-transform: capitalize;
  }
}

.alerta {
  background: #ef4411;
  margin-top: 10px;
  border-radius: 5px;

  span {
    background: #fabeac;
    border-radius: 0 5px 5px 0;
    margin-left: 7px;
    display: block;
    padding: 5px 10px;
    color: #080d3acc;

    i {
      vertical-align: middle;
      margin-right: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dashboard/pages/Domain.vue